import { faRotate } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { ReactNode } from "react";
import { PrimaryButton } from "./Buttons";

interface DashboardMetricProps {
    value?: string | number;
    label: string;
}

export const DashboardMetric = (props: DashboardMetricProps) => (
    <div className="grow">
        <div className="text-xl mb-1">{props.value}</div>
        <div className="text-sm text-zinc-600 font-semibold">{props.label}</div>
    </div>
);

interface DashboardStatsGroupProps {
    title: string;
    children: ReactNode;
}

export const DashboardStatsGroup = (props: DashboardStatsGroupProps) => (
    <div className="whitespace-nowrap w-full">
        <p className="text-sm font-semibold leading-snug flex items-center mb-2">
            {props.title}
        </p>
        <div className="flex gap-10">{props.children}</div>
    </div>
);

interface DashboardContainerProps {
    children: ReactNode;
    className?: string;
    paddingClassName?: string;
}

export const DashboardContainer = (props: DashboardContainerProps) => (
    <div
        className={`flex w-full ${props.paddingClassName ?? "px-6 py-8"} ${props.className ?? ""}`}
    >
        <div className="flex flex-col w-full bg-white rounded-md border-slate-200 border border-solid">
            {props.children}
        </div>
    </div>
);

interface DashboardHeaderProps {
    title?: string;
    description?: string | ReactNode;
    trailing?: ReactNode;
    actions?: {
        label: string | ReactNode;
        fn: () => void;
    }[];
}

export const DashboardHeader = (props: DashboardHeaderProps) => (
    <div className="p-4 border-b flex justify-between items-center">
        <div>
            <h1 className="text-ae-blue-900 font-semibold text-xl mb-1">
                {props.title ? (
                    props.title
                ) : (
                    <FontAwesomeIcon
                        icon={faRotate}
                        className="h-4 animate-spin"
                    />
                )}
            </h1>
            {props.description && (
                <p className="text-slate-500 font-medium text-sm">
                    {props.description}
                </p>
            )}
        </div>
        {(props.trailing || props.actions) && (
            <div className="flex gap-2">
                {props.trailing}
                {props.actions?.map((action, index) => (
                    <PrimaryButton key={index} onClick={action.fn}>
                        {action.label}
                    </PrimaryButton>
                ))}
            </div>
        )}
    </div>
);
